import getSubTreeWithId from "./getSubTreeWithId";
import isNodeInTree from "./isNodeInTree";

/**
 * @param {TreeRecord} tree
 * @param {List} rootIds
 * @param {string} childId
 */
export default (tree, rootIds, childId) => {
  const matchingRoot = rootIds.find(rId => {
    const subtree = getSubTreeWithId(tree, rId);
    return subtree ? isNodeInTree(subtree, childId) : false;
  });
  return matchingRoot ? getSubTreeWithId(tree, matchingRoot) : null;
};
